import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Tag, Tooltip } from 'antd';
import clsx from 'clsx';
import { deriveTagStyle } from 'libs/tag-style';
import TagCheckable from '../TagCheckable';
import TagForeign from '../TagForeign';
import styles from './style.module.less';
const TagContent = ({ tag, isCheckable, loadingTags, isForeign, checked, partiallyChecked, disabled, tagAbbreviation, onTagCheckChange, onTagDelete, onModalOpen, }) => {
    const tooltipTitle = useMemo(() => (tag.showFullVersion === true ? false : tag.title), [tag.showFullVersion, tag.title]);
    const tagClassName = useMemo(() => clsx(styles.beeyTag, tag.showFullVersion !== true ? styles.shortTag : ''), [tag.showFullVersion]);
    const tagStyle = useMemo(() => {
        const isFullColored = !isCheckable || checked;
        return deriveTagStyle(tag.title, tag.color, partiallyChecked, isForeign, isFullColored);
    }, [isCheckable, checked, tag.color, tag.title, partiallyChecked, isForeign]);
    const tagElement = (_jsx(Tag, { className: tagClassName, style: tagStyle, children: tag.showFullVersion === true ? tag.title : tagAbbreviation }));
    if (isCheckable) {
        return (_jsx(TagCheckable, { tag: tag, disabled: disabled, checked: checked, onTagCheckChange: onTagCheckChange, loadingTags: loadingTags, tagStyle: tagStyle }));
    }
    if (isForeign === true) {
        return (_jsx(TagForeign, { tag: tag, onModalOpen: onModalOpen, onTagDelete: onTagDelete, tooltipTitle: tooltipTitle, children: tagElement }));
    }
    return _jsx(Tooltip, { title: tooltipTitle, children: tagElement });
};
export default TagContent;
